<template>
  <div class="weiKuDetail content-small-width">
    <el-row :gutter="22">
      <!-- 左侧部分 -->
      <el-col :span="6" class="left">
        <el-row>
          <el-col :span="24">
            <div class="img-bg">
              <img src="../assets/img/13.png" alt style="width:100%" />
              <div class="one-book-title-box start-left-right-end-shu">{{name}}</div>
            </div>
            <!-- <img src="../assets/img/jingluo.jpg" alt class="imgD" /> -->
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="l-title">
              <img src="../assets/img/jingluo.png" alt /> 目录
            </div>
            <ul class="l-ul">
              <li v-for="(item,index) in muLuList" :class="item.id === id ? 'muLuListid' : ''" :key="index" @click="getChapterDetail(item.id)">
                {{limitMaxWords(13,item.chapter)}}
                <span class="orange fr">{{item.readStatus?'已读':''}}</span>
              </li>
            </ul>
            <el-pagination class="page"
            background
            style="padding-top: 10px!important;padding-bottom: 10px!important;"
              :hide-on-single-page="false"
               @current-change="muluChange"
               :pager-count="3"
              :total="muluTotal"
              :page-size="pageSize2"
              :small="true"
              layout="prev, pager, next,jumper">
            </el-pagination>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="adv-wrap">
            <div
              class="common-img-outer setPositon listdetail-adver-outer-img"
              v-for="(item,index) in wenkuAdverList"
              :key="index"
            >
              <a :href="item.urlLink">
                <img :src="$store.state.imgUrl+item.urlImage" alt style="width:100%" />
                <span class="adver-words-tip" v-if="item.urlImage">{{adverWordsTip}}</span>
              </a>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <!-- 右侧部分 -->
      <el-col :span="18">
        <el-row>
          <el-col :span="16">
            <span class="large-title">{{name}}{{chapter}}</span>
          </el-col>
          <el-col :span="8" class="btn-group text-right">
            <el-button
              size="small"
              icon="el-icon-star-on"
              class="btn1"
              :class="isCollection?'red':'grey'"
              @click="collectPer()"
            >收藏</el-button>
            <el-button size="small" icon="el-icon-share" class="btn1 grey" @click="shareF()">分享</el-button>
            <div>
              <share :config="config1" style="display:inline-block" v-if="isShare"></share>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <span class="browse-count">浏览量：{{llCount}}</span>
          </el-col>
          <el-col :span="24" class="jiangshi">
            <span>{{categoryName}}&nbsp;&nbsp;&nbsp;&nbsp; 年代：{{yearName}} &nbsp;&nbsp;&nbsp;&nbsp;作者：{{author}}</span>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-col :span="8">
            <el-tag type="danger" @click="setFontSize(0)" class="shou">小</el-tag>
            <el-tag type="danger" @click="setFontSize(1)" class="shou">标准</el-tag>
            <el-tag type="danger" @click="setFontSize(2)" class="shou">大</el-tag>
            <el-tag type="danger" @click="setFontSize(3)" class="shou">特大</el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="r-intro">{{ articleTitle }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="r-intro" v-html="text" id="contentChapter"></el-col>
        </el-row>
        <el-row class="text-center">
          <el-button @click="shang()">上一章</el-button>
          <el-button @click="xia()">下一章</el-button>
          <!-- <el-row>
                        <el-pagination
                            prev-text="上一章"
                            next-text="下一章"
                            class="my-page"
                            background
                            layout="prev, pager, next"
                            :total="1000"
                        ></el-pagination>
          </el-row>-->
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "weiKuDetail",
  data() {
    return {
      routerId: "",
      id: "",
      muLuList: [], //目录list
      name: "",
      chapter: "",
      llCount: "",
      categoryName: "",
      yearName: "",
      author: "",
      text: "",
      nextId: "",
      preId: "",
      articleTitle:'',
      muluTotal:0,
      muluPageNum:1,
      pageSize2:5
    };
  },
  methods: {
    setFontSize(a) {
      if (a == 0) {
        document.getElementById("contentChapter").style.fontSize = "12px";
      } else if (a == 1) {
        document.getElementById("contentChapter").style.fontSize = "16px";
      } else if (a == 2) {
        document.getElementById("contentChapter").style.fontSize = "20px";
      } else {
        document.getElementById("contentChapter").style.fontSize = "24px";
      }
    },
    //得到左侧目录
    async getMulu(id) {
      let that = this;
      let url = "/medicineLibraryBooks/findPageDetails";
      let parmas = {
        bookId: id,
        pageNum:that.muluPageNum,
        pageSize:that.pageSize2,
      };
      await that.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            that.muLuList = [];
            that.muLuList = res.data.data.list;
            that.muluTotal = res.data.data.total;
            that.getChapterDetail(that.muLuList[0].id)
          } else {
            that.$message(res.data.msg);
          }
        })
        .catch(() => {
        });
    },
    //得到章节内容
    getChapterDetail(id) {
      let that = this;
      let url = "/medicineLibraryBooks/getDetails";
      let parmas = {
        id
      };
      that.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            that.text = arr.text;
            that.articleTitle = arr.chapter;
            that.nextId = arr.downId;
            that.preId = arr.upId;

          } else {
            that.$message(res.data.msg);
          }
        })
        .catch(() => {
          // that.$message("网络错误！");
        });
    },
    //上一章
    shang() {
      let that = this;
      if (!!that.preId) {
        that.getChapterDetail(that.preId);
        window.scroll(0, 0);
      } else {
        that.$message("没有上一章!");
      }
    },
    //下一章
    xia() {
      let that = this;
      if (!!that.nextId) {
        that.getChapterDetail(that.nextId);
        window.scroll(0, 0);
      } else {
        that.$message("没有下一章!");
      }
    },
    muluChange(val){
      this.muluPageNum = val;
      this.getMulu(this.id); //获取目录
    },
    // 收藏和取消收藏
    collectPer() {
      let that = this;
      if (that.isCollection) {
        //已经收藏了
        that.unCollect(that.id, 4);
      } else {
        //还没收藏呢
        that.collect(that.id, 4);
      }
    },
    getData(){
      let that = this;
      let url = "/medicineLibraryBooks/getBooks";
      let parmas = {
        id: that.$route.query.id
      };
      that.$http
        .post(url, parmas)
        .then(res => {
          if (res.data.code == 200) {
            let arr = res.data.data;
            that.name = arr.name;
            that.chapter = arr.chapter;
            that.llCount = arr.llCount;
            that.categoryName = arr.categoryName;
            that.yearName = arr.yearName;
            that.author = arr.author;
           
            that.id = arr.id
            if (arr.collectionId) {
              // 收藏了
              that.isCollection = true;
            } else {
              //没收藏
              that.isCollection = false;
            }
            that.getMulu(that.id); //获取目录
          } else {
            that.$message(res.data.msg);
          }
        })
        .catch(() => {
        });
    }
  },
  created() {
    let that = this;
    that.getPositionAdver(3, 3);
    if (!!that.$route.query.id) {
      that.routerId = that.$route.query.id;
      that.getData();
      // // 先得到目录
      // that.getMulu(that.routerId).then(res => {
      //   // 再得到该目录下的某一章节
      //   if (that.muLuList.length > 0) {
      //     that.id = that.$route.query.id;
      //     that.getChapterDetail(that.id);
      //   }
      // });
    }
  }
};
</script>

<style scoped>
/* .jiangshi {
    padding-top: 20px;
} */
.img-bg {
  /* height: 360px; */
  /* background-repeat: no-repeat; */
  /* background-image: url("../assets/img/13.png"); */
  margin-bottom: 20px;
}
.one-book-title-box {
  /* width: 50px; */
  min-height: 170px;
  padding: 1.5% 0px;
  background-color: #ffffff;
  border: solid 1px #6c6b69;
  font-size: 22px;
  line-height: 40px;
  letter-spacing: 4px;
  color: #444444;
  position: absolute;
  top: 20%;
  left: 34%;
  text-align: center;
}
.orange {
  color: orange;
  margin-right: 10px;
}
.l-ul li {
  padding-left: 16px;
}
.muLuListid{
   background-color: orange;
   color: #fff;
}
>>>.page .el-pagination__jump{
  margin-left:0;
}
>>>.page .el-pagination__editor.el-input{
  width:35px;
}
</style>



// WEBPACK FOOTER //
// src/components/weiKuDetail.vue